import type { SupplierOut } from "./api";
import { phoneSearchQuery } from "../../phone";

export type SupplierMode = "none" | "existing" | "new";

export function filterSuppliers(suppliers: SupplierOut[], query: string): SupplierOut[] {
  const nameNeedle = query.trim().toLocaleLowerCase("uz");
  if (!nameNeedle) return suppliers;
  const phoneNeedle = phoneSearchQuery(query).toLocaleLowerCase("uz");
  return suppliers.filter((supplier) =>
    supplier.name.toLocaleLowerCase("uz").includes(nameNeedle) ||
    Boolean(supplier.phone && phoneSearchQuery(supplier.phone).toLocaleLowerCase("uz").includes(phoneNeedle)),
  );
}
